module.exports = __webpack_public_path__ + "img/orange-and-yellow-lily.1f96d11f.webp";